export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Latin2-0ce55f86dca201c3f9329ee7d98ce928.woff2";